{
  "name": "HS_SH 12-48: Harmonics/Subharmonics combined",
  "description": "Harmonic and Subharmonic partial rows from 12° to 48° mapped onto a four octave cycle. 12 is mapped to MIDI Note 60 (Middle C), and tuned to 240 Hz. The \"subharmonic\" row is a mirroring, with intervals taken downward from a common pitch. Subharmonic chords do not exhibit the same psychoacoustic fusion and combination tone reinforcement as harmonic chords, but they produce melodically related sets that harmonise with a sustained higher pitch (e.g., in counterpoint). Some JI composers (i.e., Elsie Hamilton, Harry Partch, Ben Johnston) have worked extensively with symmetrically structured otonal / utonal harmonies.",
  "scale": [
    "13/12",
    "14/12",
    "15/12",
    "16/12",
    "17/12",
    "18/12",
    "19/12",
    "20/12",
    "21/12",
    "22/12",
    "23/12",
    "24/12",
    "25/12",
    "26/12",
    "27/12",
    "28/12",
    "29/12",
    "30/12",
    "31/12",
    "32/12",
    "33/12",
    "34/12",
    "35/12",
    "36/12",
    "37/12",
    "38/12",
    "39/12",
    "40/12",
    "41/12",
    "42/12",
    "43/12",
    "44/12",
    "45/12",
    "46/12",
    "47/12",
    "48/12",
    "192/47",
    "192/46",
    "192/45",
    "192/44",
    "192/43",
    "192/42",
    "192/41",
    "192/40",
    "192/39",
    "192/38",
    "192/37",
    "192/36",
    "192/35",
    "192/34",
    "192/33",
    "192/32",
    "192/31",
    "192/30",
    "192/29",
    "192/28",
    "192/27",
    "192/26",
    "192/25",
    "192/24",
    "192/23",
    "192/22",
    "192/21",
    "192/20",
    "192/19",
    "192/18",
    "192/17",
    "192/16",
    "192/15",
    "192/14",
    "192/13",
    "192/12"
  ],
  "key_colors_mode": "manual",
  "short_description": "72-HSS_12to48",
  "built_in_group": "Harmonics and Subharmonics",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "12",
    "13°",
    "14°",
    "15°",
    "16°",
    "17°",
    "18°",
    "19°",
    "20°",
    "21°",
    "22°",
    "23°",
    "24°",
    "25°",
    "26°",
    "27°",
    "28°",
    "29°",
    "30°",
    "31°",
    "32°",
    "33°",
    "34°",
    "35°",
    "36°",
    "37°",
    "38°",
    "39°",
    "40°",
    "41°",
    "42°",
    "43°",
    "44°",
    "45°",
    "46°",
    "47°",
    "48",
    "47",
    "46",
    "45",
    "44",
    "43",
    "42",
    "41",
    "40",
    "39",
    "38",
    "37",
    "36",
    "35",
    "34",
    "33",
    "32",
    "31",
    "30",
    "29",
    "28",
    "27",
    "26",
    "25",
    "24",
    "23",
    "22",
    "21",
    "20",
    "19",
    "18",
    "17",
    "16",
    "15",
    "14",
    "13",
    "12"
  ],
  "note_colors": [
    "#ff9898",
    "#e6d7fe",
    "#ffe5e5",
    "#fffae5",
    "#ffffff",
    "#cfcfcf",
    "#ffffff",
    "#d6f7ff",
    "#fffae5",
    "#ffe5e5",
    "#dfffd6",
    "#95c69b",
    "#ffffff",
    "#fef5be",
    "#e6d7fe",
    "#ffffff",
    "#ffe5e5",
    "#8aafff",
    "#fffae5",
    "#68f3ec",
    "#ffffff",
    "#dfffd6",
    "#cfcfcf",
    "#ffcba8",
    "#ffffff",
    "#cee3e2",
    "#d6f7ff",
    "#e6d7fe",
    "#fffae5",
    "#f89b87",
    "#ffe5e5",
    "#c9a573",
    "#dfffd6",
    "#fffae5",
    "#95c69b",
    "#ffb8da",
    "#ffffff",
    "#f4b0d1",
    "#8fbd94",
    "#f6f2db",
    "#9fe48c",
    "#c19f70",
    "#ecc5c7",
    "#ec9684",
    "#f6f2db",
    "#decef5",
    "#ceeef6",
    "#c6dad9",
    "#ffffff",
    "#eecbc9",
    "#c6c6c6",
    "#9fe48c",
    "#ffffff",
    "#65e7e0",
    "#f6f2db",
    "#84a8f4",
    "#ecc5c7",
    "#ffffff",
    "#decef5",
    "#efe9d2",
    "#ffffff",
    "#8fbd94",
    "#9fe48c",
    "#ecc5c7",
    "#f6f2db",
    "#ceeef6",
    "#ffffff",
    "#c6c6c6",
    "#ffffff",
    "#f6f2db",
    "#ecc5c7",
    "#decef5"
  ],
  "equivSteps": 72,
  "fundamental": 240,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 4,
  "drSteps": 1,
  "hexSize": 38,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3
}
